import { deltaHoursMinutes } from '@pidz/date';
import { UnsavedBlock } from '../types';

export default (block:UnsavedBlock) => {
  const { hours, minutes } = deltaHoursMinutes(block.start, block.end);
  return `${hours} uur ${minutes} min.`;
};
